export const spacing = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
  /** @deprecated Use `sm` instead (same 8px). Kept for backwards compatibility. */
  s: 8,
  /** @deprecated Use `md` instead (same 16px). Kept for backwards compatibility. */
  m: 16,
  /** @deprecated Use `lg` instead (same 24px). Kept for backwards compatibility. */
  l: 24,
};

export const radius = {
  button: 4,
  card: 12,
  contextMenu: 8,
  input: 4,
  tagSmall: 4,
  tagMedium: 6,
  tagLarge: 8,
  avatarSmall: 4,
  avatarLarge: 8,
  avatarCircle: 999,
};

/** Primitive radius scale. Mirrors Figma "Scale / radius/*" variables. */
export const radiusScale = {
  "25": 2,
  "50": 4,
  "75": 6,
  "100": 8,
  "150": 12,
  "200": 16,
  "250": 20,
  "300": 24,
  "350": 28,
  "400": 32,
  "999": 999,
} as const;

/** Primitive border-width scale. Mirrors Figma "Scale / stroke/*" variables. */
export const stroke = {
  "1": 1,
  "2": 2,
  "3": 3,
} as const;
